module.exports = __webpack_public_path__ + "img/componentes-06.9ec2e36b.png";